<template>
  <div class="text-left">
    <div class="inline-block bg-nw-dark h-screen" :class="{ 'fixed -left-3/5': !show_menu, 'w-3/5': show_menu }">
      <nav-bar v-on:show-menu="showMenu"></nav-bar>
    </div>
    <div class="inline-block w-full" :class="{ 'fixed -right-3/5': show_menu }">
      <div class="pt-12 pl-4" @click="show_menu = !show_menu">
        <menu-icon></menu-icon>
      </div>
      <div class="px-6">
        <div class="pt-12 font-extrabold text-2xl text-black">
          Good Day
          {{ user_details ? user_details.first_name : '' }},
        </div>
        <div class="pt-3 text-xl text-gray-400 w-3/4">What would you like to do today?</div>
        <div class="pt-12">
          <div class="grid grid-cols-2 gap-x-4">
            <div class="bg-nw-dark rounded-lg w-full shadow" @click="prohibited">
              <div class="pt-12 w-32 mx-auto">
                <logo-head :width="'w-32'" :height="'h-14'"></logo-head>
              </div>
              <div class="pt-3 pb-5 px-4 text-xl text-white font-extrabold text-center">Arrange a Delivery</div>
            </div>
            <div class="bg-nw-red rounded-lg w-full shadow" @click="current">
              <div class="pt-14 w-20 mx-auto">
                <bicycle-icon></bicycle-icon>
              </div>
              <div class="pt-3 pb-5 px-4 text-xl text-white font-extrabold text-center">Check Deliveries</div>
            </div>
          </div>
        </div>
        <div class="border-2 border-nw-dark mt-4 rounded-lg shadow-md px-6" @click="history">
          <div class="py-9 inline-block">
            <history-icon></history-icon>
          </div>
          <div class="inline-block absolute mt-9 pl-5 text-2xl font-extrabold">Delivery History</div>
        </div>
      </div>
    </div>
    <div class="fixed left-0 top-0 w-full bg-dark-transparent h-screen" v-if="loader">
      <div class="absolute top-2/4 w-full">
        <loading :width="'w-10'" :height="'h-10'"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import BicycleIcon from '../components/icons/BicycleIcon.vue'
import HistoryIcon from '../components/icons/HistoryIcon.vue'
import LogoHead from '../components/icons/LogoHead.vue'
import MenuIcon from '../components/icons/MenuIcon.vue'
import NavBar from '../components/NavBar.vue'
import uniqid from 'uniqid'
import { mapState } from 'vuex'
import Loading from '../components/icons/Loading.vue'
import Swal from 'sweetalert2'

export default {
  components: {
    MenuIcon,
    LogoHead,
    BicycleIcon,
    HistoryIcon,
    NavBar,
    Loading
  },
  data() {
    return {
      show_menu: false,
      loader: false
    }
  },
  computed: {
    ...mapState('arrange', ['loading', 'unfinished']),
    user_details() {
      return this.$store.state.user_details
    }
  },
  methods: {
    prohibited() {
      this.loader = true
      if (this.unfinished == '') {
        var uniqueId = uniqid()
        this.$store.dispatch('arrange/startArrangement', uniqueId)
      } else {
        this.loader = false
        Swal.fire({
          text: "You have'nt finished placing your last order",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Continue with last order`,
          denyButtonText: `Delete and start new order`
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$router.push({
              name: 'Arrange',
              params: { id: this.unfinished }
            })
          } else if (result.isDenied) {
            this.$store.dispatch('arrange/deleteArrangement', this.unfinished).then(() => {
              var uniqueId = uniqid()
              this.$store.dispatch('arrange/startArrangement', uniqueId)
            })
          }
        })
      }
    },
    showMenu(val) {
      this.show_menu = val
    },
    history() {
      this.$router.push({
        name: 'History'
      })
    },
    current() {
      this.$router.push({
        name: 'CurrentDeliveries'
      })
    }
  },
  mounted() {
    this.$store.dispatch('middleware/isLoggedIn')
    this.$store.dispatch('arrange/hasUnfinishedOrder')
  }
}
</script>

<style>
.menu-rounded-top {
  border-bottom-right-radius: 3.5rem;
}
</style>
